import { MesaLogo } from '@/src/assets/icons/MesaLogo'
import { MesaMonogram } from '@/src/assets/icons/MesaMonogram'
import { MesaHeader } from '@/src/common/modules/RewardsSection/MesaHeader'
import { fontFamilies, mesaColorNames } from '@/src/common/theme'
import { View, Text } from 'react-native'

export function Header() {
  return (
    <MesaHeader>
      <MesaMonogram />
      <View style={{ position: 'absolute', margin: 'auto', alignItems: 'center' }}>
        <MesaLogo variant="dualtone-white" height={53} width={139} />
        <Text
          style={{
            fontFamily: fontFamilies['PlusJakartaSans-ExtraBold'],
            fontWeight: 800,
            fontSize: 42,
            letterSpacing: 0,
            lineHeight: 37.8,
            color: mesaColorNames['Mesa - Brand/White #FFFFFF'],
            textAlign: 'center',
          }}
        >
          Home
        </Text>
      </View>
    </MesaHeader>
  )
}
